import { render, staticRenderFns } from "./RankingListItem.vue?vue&type=template&id=2bba27a3&scoped=true&"
import script from "./RankingListItem.vue?vue&type=script&lang=js&"
export * from "./RankingListItem.vue?vue&type=script&lang=js&"
import style0 from "./RankingListItem.vue?vue&type=style&index=0&id=2bba27a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba27a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VListItem,VListItemAvatar,VListItemContent,VListItemIcon,VListItemTitle})
